import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { EnvironmentMetadata } from './environment-metadata';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentMetadataService {
  buildEnvironmentMetadata(): EnvironmentMetadata {
    return {
      production: environment.production,
    };
  }
}
